/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-else-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-alert */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Info, Trash2 } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import adminServices from '../../../services/adminServices';
import { DisplayConfiguration, SourceBox, ChapterBox, createSection, createVariantModule, Preview, ButtonLabel } from './form_utils';

const AssessmentCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const assessmentType = params.get('type') === 'adaptive' ? 'adaptive' : 'linear';
  const isAdaptive = assessmentType === 'adaptive';
  const [activeTab, setActiveTab] = useState('edit');
  const [displayConfig, setDisplayConfig] = useState({ language: "English", bullets: [""], syllabus: [] });
  const [scoreDetails, setScoreDetails] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({ length: '', batch: [], Subject: "", title: '', description: '', category: '', subcategory: '', duration: '60', totalmarks: '', positivemarks: '', negativemarks: '',internaltitle:'' });
  const [allowNavigation, setAllowNavigation] = useState(false);
  const [allowCalculator, setAllowCalculator] = useState(false);
  const [sourceList, setSourceList] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [assessmentSubType, setAssessmentSubType] = useState([]);
  const [isPublishing, setIsPublishing] = useState(false);
  const [sections, setSections] = useState([]);
  const [variants, setVariants] = useState([]);
  const [activeVariantDifficulty, setActiveVariantDifficulty] = useState("Easy");
  const [assessmentDetail, setAssessmentDetail] = useState('');
  const [assessmentCategory, setAssessmentCategory] = useState([]);
  const [showBreakConfig, setShowBreakConfig] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [branchingConfig, setBranchingConfig] = useState({ highThreshold: '', lowThreshold: '', mediumRangeMin: '', mediumRangeMax: '' });
  const [breakpage, setBreakpage] = useState({ title: '', message: '' });
  const [breakpages, setBreakpages] = useState([{ id: Date.now(), title: "", message: "" }]);
  const [showVariantDeleteModal, setShowVariantDeleteModal] = useState(false);
  const [variantToDelete, setVariantToDelete] = useState(null);
  const [sectionBreaks, setSectionBreaks] = useState({});
  const [thumbImage, setThumbImage] = useState(null);
  const [thumbPreview, setThumbPreview] = useState(null);
  const [thumbImageError, setThumbImageError] = useState('');
  const [assessmentTypeList, setAssessmentTypeList] = useState([]);
  const [isBatchOpen, setIsBatchOpen] = useState(false);

  useEffect(() => {
    const blurNumberInputOnWheel = (e) => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', blurNumberInputOnWheel, { passive: true });
    return () => document.removeEventListener('wheel', blurNumberInputOnWheel);
  }, []);
  useEffect(() => {
    if (!sourceList?.length) return;

    setSections(prev =>
      prev.map(section => {
        const selectedType = section.questionType || "";
        return {
          ...section,
          sources: section.sources.map(src => {
            const sourceData = sourceList.find(s => s.id === src.sourceId);
            if (!sourceData) return src;
            const chapters = src.chapters ?? src.chapter_ids ?? [];
            const filteredQuestionIds = sourceData.chapters
              ?.filter(ch => chapters.includes(ch.id))
              ?.flatMap(ch =>
                (ch.questions_list || [])
                  .filter(q => (selectedType ? q.type === selectedType : true))
                  .map(q => q.id)
              ) || [];
            return {
              ...src,
              questioncount: new Set(filteredQuestionIds).size,
              questiontype: getTypeCounts(sourceData, chapters, selectedType)
            };
          })
        };
      })
    );

    setVariants(prev =>
      prev.map(variant => {
        const selectedType = variant.questionType || "";
        const newDifficulties = {};
        ["Easy", "Medium", "Hard"].forEach(level => {
          const sources = variant.difficulties?.[level]?.sources || [];
          const updatedSources = sources.map(src => {
            const sourceData = sourceList.find(s => s.id === src.sourceId);
            if (!sourceData) return src;
            const chapters = src.chapters ?? src.chapter_ids ?? [];
            const filteredQuestionIds = sourceData.chapters
              ?.filter(ch => chapters.includes(ch.id))
              ?.flatMap(ch =>
                (ch.questions_list || [])
                  .filter(q => (selectedType ? q.type === selectedType : true))
                  .map(q => q.id)
              ) || [];
            return {
              ...src,
              questioncount: new Set(filteredQuestionIds).size,
              questiontype: getTypeCounts(sourceData, chapters, selectedType)
            };
          });
          newDifficulties[level] = { ...variant.difficulties[level], sources: updatedSources };
        });
        return { ...variant, difficulties: newDifficulties };
      })
    );
  }, [sourceList]);

  const handleAssessmentTypeToggle = (value) => {
    setFormData((prev) => {
      const current = prev.batch || [];

      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];

      return {
        ...prev,
        batch: updated,
      };
    });


  };


  const handleDisplayConfigChange = (config) => {
    setDisplayConfig(config);
    setErrors((prev) => {
      if (!prev.displayConfig) return prev;
      const displayErrors = { ...prev.displayConfig };
      const bullets = config.bullets || [];
      if (bullets.some(b => b?.trim())) { delete displayErrors.bulletsGeneral; }
      if (bullets.every(b => b?.trim())) {
        delete displayErrors.bullets;
      }
      if ((config.syllabus || []).length > 0) {
        delete displayErrors.syllabusGeneral;
      }
      if (Array.isArray(displayErrors.syllabus)) {
        displayErrors.syllabus = displayErrors.syllabus.map((subjectErr, sIndex) => {
          const subject = config.syllabus?.[sIndex];
          if (!subjectErr || !subject) return subjectErr;
          const updated = { ...subjectErr };
          if (subject.chapters?.length > 0) delete updated.chaptersGeneral;
          if (Array.isArray(updated.chapterErrors)) {
            updated.chapterErrors = updated.chapterErrors.map((chErr, cIndex) => {
              const chapter = subject.chapters?.[cIndex];
              if (!chErr || !chapter) return chErr;
              const updatedCh = { ...chErr };
              if (chapter.chapter?.trim()) delete updatedCh.chapter;
              return updatedCh;
            });
          }
          return updated;
        });
      }
      return { ...prev, displayConfig: displayErrors };
    });
  };

  const buildAssessmentPreview = () => {
    const validBreaks = Array.isArray(breakpages) ? breakpages.filter(b => b?.title || b?.message) : [];
    return {
      basicInformation: { title: formData.title, type: formData.length, description: formData.description, category: formData.category, duration: formData.duration ,internaltitle:formData.internaltitle},
      breakdetails: validBreaks.length ? validBreaks : null,
      assessmentType: assessmentType === 'adaptive' ? 'Adaptive' : 'Linear', ...(assessmentType === 'adaptive' ? { sections, branching_config: branchingConfig, variant_modules: variants, break_time: 11 } : { sections })
    };
  };
  const previewData = buildAssessmentPreview();

  const addBreakScreen = () => {
    setBreakpages((prev) => [...prev, { id: Date.now(), title: "", message: "" }]);
  };

  const removeBreakScreen = (id) => {
    setBreakpages((prev) => prev.filter((item) => item.id !== id));
  };

  // useEffect(() => {
  //   if (formData.category) {
  //     getSourcesBaseonCategory(formData.category)
  //     getAssessmentSubject(formData.category)
  //     getAssessmentSubType(formData.category)
  //   }
  // }, [formData.category])
  useEffect(() => {
  if (formData.category) {
    const selectedItem = assessmentTypeList?.find(item => item.code === formData.category);
    if (selectedItem) {
      getSourcesBaseonCategory(selectedItem.id);
      getAssessmentSubject(selectedItem.id);
      getAssessmentSubType(selectedItem.id);
    }
  }
}, [formData.category, assessmentTypeList]);

  const getSourcesBaseonCategory = async (category) => {
    const result = await adminServices.getSourceBasedonCategory(category)
    const filtered = (result.data || []).filter(source => {
      const chapters = source.chapters || [];
      if (chapters.length === 0) return false;
      const chaptersWithQuestions = chapters.filter(ch => (ch.questions_list || []).length > 0);
      return chaptersWithQuestions.length > 0;
    });
    const filteredWithCleanChapters = filtered.map(source => ({
      ...source,
      chapters: (source.chapters || []).filter(ch =>
        (ch.questions_list || []).length > 0
      )
    }));

    setSourceList(filteredWithCleanChapters);
  }

  const getAssessmentSubject = async (category) => {
    const result = await adminServices.getAssessmentSubject(category)
    setSubjects(result.data.data)
  }

  const getAssessmentSubType = async (category) => {
    const result = await adminServices.getAssessmentSubType(category)
    setAssessmentSubType(result.data.data)
  }

  const handleChangeBreakPage = (id, e) => {
    const { name, value } = e.target;
    setBreakpages((prev) => prev.map((item) => item.id === id ? { ...item, [name]: value } : item));
    setErrors((prev) => ({ ...prev, break: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    if (name === 'category' || name === 'length') {
      const emptyDist = { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 };
      setSections(prev => prev.map(s => ({ ...s, sources: [], questionperattempt: '', questionTypeDistribution: { ...emptyDist } })));
      setVariants(prev => prev.map(v => ({
        ...v,
        questionperattempt: '',
        difficulties: {
          Easy: { ...v.difficulties.Easy, sources: [], questionTypeDistribution: { ...emptyDist } },
          Medium: { ...v.difficulties.Medium, sources: [], questionTypeDistribution: { ...emptyDist } },
          Hard: { ...v.difficulties.Hard, sources: [], questionTypeDistribution: { ...emptyDist } },
        }
      })));
    }
  };
  const handleBranchingChange = (e) => {
    const { name, value } = e.target;
    setErrors(prev => ({ ...prev, branch: "" }));
    if (value === "") {
      setBranchingConfig(prev => ({ ...prev, [name]: "" }));
      return;
    }
    const integerValue = value.split('.')[0];
    if (!/^[0-9]+$/.test(integerValue)) return;
    const num = parseInt(integerValue, 10);
    if (num > 100) return;
    setBranchingConfig(prev => ({
      ...prev,
      [name]: num
    }));
  };

  const handleCancel = () => {
    setShowCancelModal(true);
  };

  const confirmCancel = () => {
    setShowCancelModal(false);
    navigate('/app/assessments');
  };

  const closeCancelModal = () => {
    setShowCancelModal(false);
  };
  const imageWidthAndHeight = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function onReaderLoad() {
        const img = new Image();
        img.onload = function onImageLoad() { resolve({ width: img.width, height: img.height }); };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });

  const handleThumbFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setThumbImageError('');
    if (file.size >= 2097152) {
      setThumbImageError('Maximum file size is 2MB');
      return;
    }
    imageWidthAndHeight(file).then((res) => {
      if (res.width >= 360 && res.height >= 200) {
        setThumbPreview(URL.createObjectURL(file));
        setThumbImage(file);
        setErrors((prev) => ({ ...prev, thumbImage: '' }));
      } else {
        setThumbImageError('Image dimensions must be at least 360x200px');
      }
    });
  };

  const uploadThumbImage = async () => {
    if (thumbImage instanceof File) {
      const imageForm = new FormData();
      imageForm.append('thumbImage', thumbImage);
      const uploadResult = await adminServices.postImag(imageForm);
      return uploadResult?.data || null;
    }
    if (typeof thumbImage === 'string') {
      return thumbImage;
    }
    return null;
  };
  const handlePublish = async () => {
    if (!validateForm()) return;
    try {
      const breakMapping = sectionBreaks ? Object.entries(sectionBreaks).map(
        ([moduleIndex, breakItem]) => ({
          break_id: breakItem.id,
          after_module: Number(moduleIndex) + 1
        })
      ) : null

      const breakData = breakpages?.map((b) => {
        const mapping = breakMapping && breakMapping.find(m => m.break_id === b.id);
        return {
          id: b.id,
          title: b.title,
          message: b.message,
          show_time: true,
          after_module: mapping ? mapping.after_module : null
        };
      });

      const hasInvalidBreak = breakData?.some(b => b.after_module === null);
      if (assessmentType === 'adaptive' && formData.length === 'Full Test' && hasInvalidBreak) {
        alert('Please assign "After Module" for all break pages before publishing.');
        return;
      }
      setIsPublishing(true);
      const imageUrl = await uploadThumbImage();
      const body = {
        title: formData.title,
        internaltitle:formData.internaltitle,
        type: formData.length,
        description: formData.description,
        category: formData.category,
        subcategory: formData.subcategory,
        duration: formData.duration,
        totalmarks: formData.totalmarks,
        positivemarks: formData.positivemarks,
        negativemarks: formData.negativemarks,
        status: 2,
        allowNavigation,
        allowCalculator,
        sections: JSON.stringify(sections),
        assessmentType: assessmentType === 'adaptive' ? 'Adaptive' : 'Linear',
        branching_config: assessmentType === 'adaptive' ? branchingConfig : [],
        variant_modules: assessmentType === 'adaptive' ? JSON.stringify(variants) : [],
        break_time: assessmentType === 'adaptive' ? JSON.stringify(breakData) : '',
        image_name: imageUrl,
        display_config: displayConfig,
        batch: formData.batch ? formData.batch : '',
        Subject: formData.Subject ? formData.Subject : ''
      };
      const result = await adminServices.AssessmentCreate(body);
      if (result.ok) {
        setFormData({ length: '', Subject: '', batch: [], title: '', description: '', category: '', subcategory: '', duration: '60', totalmarks: '', positivemarks: '', negativemarks: '',internaltitle:'' });
        setAllowNavigation(false);
        setAllowCalculator(false);
        setSections([]);
        setVariants([])
        setBranchingConfig({ highThreshold: '', lowThreshold: '', mediumRangeMin: '', mediumRangeMax: '' })
        navigate('/app/assessments');
      }
    } finally {
      setIsPublishing(false);
    }
  };

  const handleResetConfig = () => {
    setErrors((prev) => ({ ...prev, [errors.branch]: "" }));
    setBranchingConfig({ highThreshold: 70, lowThreshold: 40, mediumRangeMin: 40, mediumRangeMax: 69 })
  }

  const handleUpdateAssessment = async () => {
    if (!validateForm()) return;
    try {
      const breakMapping = sectionBreaks ? Object.entries(sectionBreaks).map(
        ([moduleIndex, breakItem]) => ({
          break_id: breakItem.id,
          after_module: Number(moduleIndex) + 1
        })
      ) : null
      const breakData = breakpages?.map((b) => {
        const mapping = breakMapping && breakMapping.find(m => m.break_id === b.id);
        return {
          id: b.id,
          title: b.title,
          message: b.message,
          show_time: true,
          after_module: mapping ? mapping.after_module : null
        };
      });

      const hasInvalidBreak = breakData?.some(b => b.after_module === null);
      if (assessmentType === 'adaptive' && formData.length === 'Full Test' && hasInvalidBreak) {
        alert('Please assign "After Module" for all break pages before publishing.');
        return;
      }
      setIsPublishing(true);
      const imageUrl = await uploadThumbImage();
      const body = {
        title: formData.title,
        internaltitle:formData.internaltitle,
        type: formData.length,
        description: formData.description,
        duration: formData.duration,
        totalmarks: formData.totalmarks,
        positivemarks: formData.positivemarks,
        negativemarks: formData.negativemarks,
        allowNavigation,
        allowCalculator,
        sections: JSON.stringify(sections),
        branching_config: assessmentType === 'adaptive' ? branchingConfig : [],
        variant_modules: assessmentType === 'adaptive' ? JSON.stringify(variants) : [],
        break_time: assessmentType === 'adaptive' ? breakData : '',
        break_time_id: assessmentDetail?.break_time_id,
        branching_config_id: assessmentDetail?.branching_config_id,
        image_name: imageUrl,
        display_config: displayConfig,
        batch: formData?.batch,
        Subject: formData?.Subject,
        subcategory: formData.subcategory

      };
      const result = await adminServices.UpdateAssessment(location?.state?.assessmentId, body);
      if (result.ok) {
        setFormData({ length: '', Subject: '', batch: [], title: '', description: '', category: '', duration: '60', totalmarks: '', positivemarks: '', negativemarks: '' ,internaltitle:''});
        setAllowNavigation(false);
        setAllowCalculator(false);
        setSections([]);
        setVariants([])
        setBranchingConfig({ highThreshold: '', lowThreshold: '', mediumRangeMin: '', mediumRangeMax: '' })
        navigate('/app/assessments');
      }
    } finally {
      setIsPublishing(false);
    }
  };

  const handleDragStart = (e, breakItem) => {
    e.dataTransfer.setData("breakItem", JSON.stringify(breakItem));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (e, index) => {
    e.preventDefault();
    const data = JSON.parse(e.dataTransfer.getData("breakItem"));

    setSectionBreaks((prev) => ({
      ...prev,
      [index]: data
    }));
  };

  const addSection = () => {
    setErrors(prev => ({ ...prev, sections: "", common: "" }));
    setSections(prev => {
      const updated = [...(prev || []),
      createSection((prev?.length || 0) + 1, isAdaptive)];
      return updated;
    });
  };
  const removeSection = (id) => {
    setVariantToDelete({ id, type: 'section' });
    setShowVariantDeleteModal(true);
  };

  const updateSection = (id, key, value) => {
    setSections(prev => {
      const updated = prev.map(section => {
        if (section.id !== id) return section;
        const updatedSection = { ...section, [key]: value };
        if (key === "questionperattempt") {
          updatedSection.questionTypeDistribution = { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 };
        }
        if (key === "questionType") {
          updatedSection.sources = section.sources.map(src => {
            const sourceData = sourceList?.find(s => s.id === src.sourceId);
            if (!sourceData) return src;
            const filteredQuestionIds = sourceData?.chapters?.filter(ch => src.chapters.includes(ch.id))?.flatMap(ch => (ch?.questions_list || []).filter(q => value ? q.type === value : true).map(q => q.id)) || [];
            return {
              ...src,
              questioncount: new Set(filteredQuestionIds).size,
              questiontype: getTypeCounts(sourceData, src.chapters, value)
            };
          });
        }
        return updatedSection;
      });
      return updated;
    });
    setErrors(prev => ({
      ...prev,
      sectionDetails: { ...prev?.sectionDetails, [id]: { ...prev?.sectionDetails?.[id], [key]: "" } }
    }));
  };

  const updateQuestionTypeDistribution = (sectionId, typeKey, value, maxAvailable) => {
    if (value.includes('.')) return;
    const numericValue = Number(value) || 0;
    if (numericValue < 0) return;
    if (numericValue > maxAvailable) return;
    const currentSection = sections.find(s => s.id === sectionId);
    const currentDistribution = currentSection?.questionTypeDistribution || {};
    const newTotal = Object.entries(currentDistribution).reduce((sum, [k, v]) => {
      return sum + (k === typeKey ? numericValue : Number(v || 0));
    }, 0);
    const qpa = Number(currentSection?.questionperattempt || 0);
    if (qpa > 0 && newTotal > qpa) return;
    setSections(prev =>
      prev.map(section => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          questionTypeDistribution: {
            ...section.questionTypeDistribution,
            [typeKey]: numericValue,
          },
        };
      }));
    setErrors(prev => ({ ...prev, sectionDetails: { ...prev?.sectionDetails, [sectionId]: { ...prev?.sectionDetails?.[sectionId], questionDistribution: "" } } }));
  };

  const updateVariantQuestionDistribution = (variantId, level, typeKey, value, maxAvailable) => {
    if (value.includes('.')) return;
    const numericValue = Number(value) || 0;
    if (numericValue < 0) return;
    if (numericValue > maxAvailable) return;
    const currentVariant = variants.find(v => v.id === variantId);
    const currentDistribution = currentVariant?.difficulties?.[level]?.questionTypeDistribution || {};
    const newTotal = Object.entries(currentDistribution).reduce((sum, [k, v]) => {
      return sum + (k === typeKey ? numericValue : Number(v || 0));
    }, 0);
    const qpa = Number(currentVariant?.questionperattempt || 0);
    if (qpa > 0 && newTotal > qpa) return;
    setVariants(prev =>
      prev.map(section => {
        if (section.id !== variantId) return section;
        return {
          ...section,
          difficulties: {
            ...section.difficulties,
            [level]: {
              ...section.difficulties[level],
              questionTypeDistribution: {
                ...section.difficulties[level]
                  .questionTypeDistribution,
                [typeKey]: numericValue
              }
            }
          }
        };
      })
    );
    setErrors(prev => {
      const updatedVariantDetails = {
        ...prev?.variantDetails,
        [variantId]: {
          ...prev?.variantDetails?.[variantId],
          questionDistribution: ""
        }
      };
      const anyVariantErrors = Object.values(updatedVariantDetails).some(
        v => Object.values(v).some(val => val !== "")
      );
      return {
        ...prev,
        variants: anyVariantErrors ? prev.variants : "",
        variantDetails: updatedVariantDetails
      };
    });
  };

  const getTypeCounts = (sourceData, selectedChapterIds = [], selectedType = "") => {
    const questiontype = {};
    if (selectedChapterIds.length === 0) return questiontype;
    const chaptersToUse = sourceData?.chapters?.filter(ch => selectedChapterIds.includes(ch.id)) || [];
    // A question can belong to multiple selected chapters (q.chapter_id is an array),
    // so dedupe by question id to count each distinct question only once.
    const seenIds = new Set();
    chaptersToUse.forEach(ch => {
      ch?.questions_list?.forEach(q => {
        if (selectedType && q.type !== selectedType) return;
        if (seenIds.has(q.id)) return;
        seenIds.add(q.id);
        if (!questiontype[q.type]) {
          questiontype[q.type] = 0;
        }
        questiontype[q.type]++;
      });
    });
    return questiontype;
  };

  const toggleArray = (sectionId, key, value) => {
    setSections(prev =>
      prev.map(section => {
        if (section.id !== sectionId) return section;
        if (key === "sources") {
          const exists = section.sources.find(s => s.sourceId === value);
          if (exists) {
            return {
              ...section,
              sources: section.sources.filter(s => s.sourceId !== value)
            };
          } else {
            const sourceData = sourceList?.find(s => s.id === value);
            if (!sourceData) return section;
            return {
              ...section,
              sources: [
                ...section.sources, {
                  sourceId: value,
                  chapters: [],
                  questioncount: 0,
                  questiontype: {}
                }
              ]
            };
          }
        }
        if (key === "chapters") {
          return {
            ...section,
            sources: section.sources.map(src => {
              const sourceData = sourceList?.find(s => s.id === src.sourceId);
              if (!sourceData) return src;
              const belongs = sourceData?.chapters?.some(c => c.id === value);
              if (!belongs) return src;
              const chapterExists = src.chapters.includes(value);
              const updatedChapters = chapterExists ? src.chapters.filter(id => id !== value) : [...src.chapters, value];
              const selectedType = section.questionType || "";
              let updatedQuestionIds = [];
              if (updatedChapters.length > 0) {
                updatedQuestionIds = sourceData?.chapters?.filter(ch => updatedChapters.includes(ch.id))
                  ?.flatMap(ch =>
                    (ch?.questions_list || [])
                      .filter(q =>
                        selectedType
                          ? q.type === selectedType
                          : true
                      )
                      .map(q => q.id)
                  ) || [];
              }
              // const updatedQuestionCount = updatedQuestionIds.length;
              const updatedQuestionCount = new Set(updatedQuestionIds).size;
              const updatedTypeCounts =
                getTypeCounts(
                  sourceData,
                  updatedChapters,
                  selectedType
                );

              return {
                ...src,
                chapters: updatedChapters,
                questioncount: updatedQuestionCount,
                questiontype: updatedTypeCounts
              };
            })
          };
        }
        return section;
      })
    );

    setErrors(prev => ({
      ...prev,
      sectionDetails: {
        ...prev?.sectionDetails,
        [sectionId]: {
          ...prev?.sectionDetails?.[sectionId],
          [key]: "",
          ...(key === "chapters" ? { chapters: "" } : {}),
          ...(key === "sources" ? { sources: "" } : {})
        }
      }
    }));
  };

  const selectAllSources = (sectionId) => {
    setSections(prev =>
      prev.map(section => {
        if (section.id !== sectionId) return section;
        const updatedSources = sourceList.map(sourceData => {
          return {
            sourceId: sourceData.id,
            chapters: [],
            questioncount: 0,
            questiontype: {}
          };
        });

        return {
          ...section,
          sources: updatedSources
        };
      })
    );

    setErrors(prev => ({
      ...prev,
      sectionDetails: {
        ...prev?.sectionDetails,
        [sectionId]: {
          ...prev?.sectionDetails?.[sectionId],
          sources: "",
          chapters: ""
        }
      }
    }));
  };

  const deselectAllSources = (sectionId) => {
    setSections(prev =>
      prev.map(section =>
        section.id === sectionId
          ? { ...section, sources: [] }
          : section
      )
    );
  };

  const deselectAllChapters = (sectionId) => {
    setSections(prev =>
      prev.map(section => {
        if (section.id !== sectionId) return section;
        return {
          ...section,
          sources: section.sources.map(src => {
            const sourceData = sourceList.find(s => s.id === src.sourceId);
            if (!sourceData) return src;
            return {
              ...src,
              chapters: [],
              questioncount: 0,
              questiontype: {}
            };
          })
        };
      })
    );
  };

  const validateForm = () => {
    const newErrors = {};
    const sectionErrors = {};
    const variantErrors = {};

    if (!formData.title?.trim()) {
      newErrors.title = "Assessment title is required";
    }
    if (!formData.internaltitle?.trim()) {
      newErrors.internaltitle = "Assessment internaltitle is required";
    }
    

    if (!thumbImage && !thumbPreview) {
      newErrors.thumbImage = "Thumb image is required";
    }

    if (!formData.length) {
      newErrors.length = "Please select assessment type";
    }

    if (!formData.duration) {
      newErrors.duration = "Please add Duration";
    }



    if (!formData.totalmarks) {
      newErrors.totalmarks = "Please add Marks";
    }
    if (!formData.positivemarks) {
      newErrors.positivemarks = "Please add Positive Marks";
    }
    if (formData.negativemarks === '' || formData.negativemarks === null || formData.negativemarks === undefined) {
      newErrors.negativemarks = "Please add NegativeMarks";
    }


    if (formData.duration && sections.length > 0) {
      const overall = Number(formData.duration);
      if (!isAdaptive) {
        const sectionTotal = sections.reduce(
          (sum, sec) => sum + (Number(sec.time) || 0), 0
        );
        if (sectionTotal !== overall) {
          newErrors.duration = 'Total duration of all sections must equal overall duration.';
        }
      } else {
        const foundationTotal = sections.reduce((sum, sec) => sum + (Number(sec.time) || 0), 0);
        const variantTotal = variants.reduce((sum, v) => sum + (Number(v.time) || 0), 0);
        if (foundationTotal + variantTotal !== overall) {
          newErrors.duration = 'Total duration of Foundation and Variant modules must equal overall duration.';
        }
      }
    }
    if (isAdaptive) {
      const { highThreshold, lowThreshold, mediumRangeMin, mediumRangeMax } = branchingConfig || {};
      if (highThreshold === '' || lowThreshold === '' || mediumRangeMin === '' || mediumRangeMax === '') {
        newErrors.branch = "Please fill all the branching configuration details";
      }

      if (!sections?.length) {
        newErrors.sections = "Please create Foundation Modules";
      }

      if (!variants?.length) {
        newErrors.variants = "Please create Variant Modules";
      }

      if (sections?.length && variants?.length && sections.length !== variants.length) {
        newErrors.common = "Variants and Foundation Modules count must be equal";
      }

      if (formData?.length === 'Full Test') {
        const invalidBreak = breakpages.some((b) => !b.title?.trim() || !b.message?.trim());
        if (invalidBreak) {
          newErrors.break = "Break Title and Message required for all break screens";
        }
      }
      sections?.forEach((section) => {
        const err = {};
        if (!section.name?.trim()) err.name = "Name required";
        if (!section.time) err.time = "Time required";
        if (isAdaptive && !section.scoretemplate) {
          err.scoretemplate = "ScoreTemplate required";
        }
        if (!section.sources?.length) {
          err.sources = "Select at least one source";
        } else {
          const hasChapters = section.sources.some(src => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            return Array.isArray(chapterList) && chapterList.length > 0;
          });
          if (!hasChapters) err.chapters = "Select at least one chapter";
        }

        if (
          section.questionperattempt == null ||
          section.questionperattempt === '' ||
          isNaN(section.questionperattempt) ||
          Number(section.questionperattempt) <= 0
        ) {
          err.questionperattempt = "Questions per attempt must be greater than 0";
        } else {
          const availableQuestions = section.sources.reduce((sum, src) => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
            const typeCounts = src.questiontype || {};
            const typeSum = Object.values(typeCounts).reduce((a, b) => a + (Number(b) || 0), 0);
            return sum + (typeSum > 0 ? typeSum : (Number(src.questioncount) || 0));
          }, 0);
          if (Number(section.questionperattempt) > availableQuestions) {
            err.questionperattempt = `Questions per attempt (${section.questionperattempt}) cannot exceed available questions (${availableQuestions})`;
          }
        }

        const QUESTION_TYPE_KEYS = ["MCQ", "MCQ_MULTI", "PASSAGE_SINGLE", "PASSAGE_MULTI", "NUMERIC"];
        QUESTION_TYPE_KEYS.forEach(typeKey => {
          const available = section.sources.reduce((total, src) => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            if (!Array.isArray(chapterList) || chapterList.length === 0) return total;
            return total + (src?.questiontype?.[typeKey] || 0);
          }, 0);
          const distributed = Number(section.questionTypeDistribution?.[typeKey] || 0);
          if (distributed > available) {
            err.questionDistribution = "Distributed count exceeds available questions for one or more types.";
          }
        });
        const adaptiveDistributedTotal = Object.values(section.questionTypeDistribution || {})
          .reduce((sum, v) => sum + Number(v || 0), 0);
        if (Number(section.questionperattempt) > 0 && adaptiveDistributedTotal < Number(section.questionperattempt)) {
          err.questionDistribution = "Please complete the question type distribution";
        }
        if (Object.keys(err).length) sectionErrors[section.id] = err;
      });

      // Variant module validation
      variants?.forEach((variant) => {
        const err = {};
        if (!variant.name?.trim()) err.name = "Variant name required";
        if (!variant.time) err.time = "Time required";

        if (
          variant.questionperattempt == null ||
          variant.questionperattempt === '' ||
          isNaN(variant.questionperattempt) ||
          Number(variant.questionperattempt) <= 0
        ) {
          err.questionperattempt = "Questions per attempt must be greater than 0";
        } else {
          ["Easy", "Medium", "Hard"].forEach(level => {
            const availableQuestions = (variant.difficulties[level]?.sources || []).reduce((sum, src) => {
              const chapterList = src.chapters ?? src.chapter_ids ?? [];
              if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
              return sum + (Number(src.questioncount) || 0);
            }, 0);
            if (Number(variant.questionperattempt) > availableQuestions) {
              err.questionperattempt = `Questions per attempt (${variant.questionperattempt}) exceeds available questions for ${level} (${availableQuestions})`;
            }
          });
        }

        const VARIANT_TYPE_KEYS = ["MCQ", "MCQ_MULTI", "PASSAGE_SINGLE", "PASSAGE_MULTI", "NUMERIC"];
        const exceededLevels = [];
        ["Easy", "Medium", "Hard"].forEach(level => {
          const levelDistributed = Object.values(
            variant.difficulties[level]?.questionTypeDistribution || {}
          ).reduce((sum, v) => sum + Number(v || 0), 0);
          if (Number(variant.questionperattempt) > 0 && levelDistributed > Number(variant.questionperattempt)) {
            err.questionDistribution = `Distributed total exceeds questions per attempt for ${level}`;
          }
          VARIANT_TYPE_KEYS.forEach(typeKey => {
            const levelSources = variant.difficulties[level]?.sources || [];
            const available = levelSources.reduce((total, src) => {
              const chapterList = src.chapters ?? src.chapter_ids ?? [];
              if (!Array.isArray(chapterList) || chapterList.length === 0) return total;
              return total + (src?.questiontype?.[typeKey] || 0);
            }, 0);
            const distributed = Number(variant.difficulties[level]?.questionTypeDistribution?.[typeKey] || 0);
            if (distributed > available && !exceededLevels.includes(level)) {
              exceededLevels.push(level);
            }
          });

          if (!variant.difficulties[level]?.sources?.length) {
            err[level] = `${level} sources required`;
          } else {
            const hasChapters = variant.difficulties[level].sources.some(src => {
              const chapterList = src.chapters ?? src.chapter_ids ?? [];
              return Array.isArray(chapterList) && chapterList.length > 0;
            });
            if (!hasChapters) err[level] = `${level} - select at least one chapter`;
          }
        });

        if (exceededLevels.length > 0) {
          err.questionDistribution = `Distributed count exceeds available questions in ${exceededLevels.join(", ")}.`;
        }
        ["Easy", "Medium", "Hard"].forEach(level => {
          const levelDistributed = Object.values(
            variant.difficulties[level]?.questionTypeDistribution || {}
          ).reduce((sum, v) => sum + Number(v || 0), 0);
          if (Number(variant.questionperattempt) > 0 && levelDistributed < Number(variant.questionperattempt)) {
            err.questionDistribution = `Please complete the question type distribution for ${level}`;
          }
        });

        if (Object.keys(err).length) variantErrors[variant.id] = err;
      });

      if (Object.keys(variantErrors).length) {
        newErrors.variantDetails = variantErrors;
        newErrors.variants = "Please complete all variant modules (Easy, Medium and Hard)";
      }
    }

    if (!isAdaptive) {
      if (!sections?.length) {
        newErrors.sections = "Please create Section Modules";
      }

      sections?.forEach((section) => {
        const err = {};
        if (!section.name?.trim()) err.name = "Name required";
        if (!section.time) err.time = "Time required";

        if (!section.sources?.length) {
          err.sources = "Select at least one source";
        } else {
          const hasChapters = section.sources.some(src => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            return Array.isArray(chapterList) && chapterList.length > 0;
          });
          if (!hasChapters) err.chapters = "Select at least one chapter";
        }

        if (!section.difficulty) err.difficulty = "Select difficulty";

        if (
          section.questionperattempt == null ||
          section.questionperattempt === '' ||
          isNaN(section.questionperattempt) ||
          Number(section.questionperattempt) <= 0
        ) {
          err.questionperattempt = "Questions per attempt must be greater than 0";
        } else {
          const availableQuestions = section.sources.reduce((sum, src) => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
            return sum + (Number(src.questioncount) || 0);
          }, 0);
          if (Number(section.questionperattempt) > availableQuestions) {
            err.questionperattempt = `Questions per attempt (${section.questionperattempt}) cannot exceed available questions (${availableQuestions})`;
          }
        }

        const distributedTotal = Object.values(section.questionTypeDistribution || {}).reduce(
          (sum, v) => sum + Number(v || 0), 0
        );
        if (Number(section.questionperattempt) > 0 && distributedTotal < Number(section.questionperattempt)) {
          err.questionDistribution = "Please complete the question type distribution";
        }

        const QUESTION_TYPE_KEYS = ["MCQ", "MCQ_MULTI", "PASSAGE_SINGLE", "PASSAGE_MULTI", "NUMERIC"];
        QUESTION_TYPE_KEYS.forEach(typeKey => {
          const available = section.sources.reduce((total, src) => {
            const chapterList = src.chapters ?? src.chapter_ids ?? [];
            if (!Array.isArray(chapterList) || chapterList.length === 0) return total;
            return total + (src?.questiontype?.[typeKey] || 0);
          }, 0);
          const distributed = Number(section.questionTypeDistribution?.[typeKey] || 0);
          if (distributed > available) {
            err.questionDistribution = "Distributed count exceeds available questions for one or more types.";
          }
        });

        if (Object.keys(err).length) sectionErrors[section.id] = err;
      });
    }

    if (Object.keys(sectionErrors).length) {
      newErrors.sectionDetails = sectionErrors;
    }

    const displayErrors = {};

    const bullets = displayConfig.bullets || [];
    const nonEmptyBullets = bullets.filter((b) => b?.trim());
    if (nonEmptyBullets.length === 0) {
      displayErrors.bulletsGeneral = "Add at least one item under 'What You'll Get'";
    } else {
      const bulletItemErrors = bullets.map((b) =>
        b !== undefined && b.trim() === "" ? "Item cannot be empty" : null
      );
      if (bulletItemErrors.some(Boolean)) {
        displayErrors.bullets = bulletItemErrors;
      }
    }

    const syllabus = displayConfig.syllabus || [];
    if (!syllabus.length) {
      displayErrors.syllabusGeneral = "Add at least one Subject and Topic under Topics Covered";
    } else {
      const syllabusErrors = [];
      syllabus.forEach((subject, sIndex) => {
        const subjectErr = {};
        if (!subject.subject?.trim()) subjectErr.subject = "Subject name required";

        if (!subject.chapters?.length) {
          subjectErr.chaptersGeneral = "Add at least one Topic under this subject";
        } else {
          const chapterErrors = [];
          subject.chapters.forEach((chapter, cIndex) => {
            const chErr = {};
            if (!chapter.chapter?.trim()) chErr.chapter = "Chapter name required";
            if (chapter.topics?.length) {
              const topicErrors = chapter.topics.map((t) =>
                t.trim() === "" ? "Topic cannot be empty" : null
              );
              if (topicErrors.some(Boolean)) chErr.topics = topicErrors;
            }
            if (Object.keys(chErr).length) chapterErrors[cIndex] = chErr;
          });
          if (chapterErrors.length) subjectErr.chapterErrors = chapterErrors;
        }
        if (Object.keys(subjectErr).length) syllabusErrors[sIndex] = subjectErr;
      });
      if (syllabusErrors.length) displayErrors.syllabus = syllabusErrors;
    }
    if (Object.keys(displayErrors).length) {
      newErrors.displayConfig = displayErrors;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addVariantModule = () => {
    setErrors(prev => ({ ...prev, variants: "", common: "" }));
    setVariants(prev => {
      const updated = [...prev, createVariantModule(prev.length + 1)];
      return updated;
    });
  };

  const confirmVariantDelete = () => {
    if (variantToDelete !== null) {
      if (variantToDelete.type === 'section') {
        setSections((prev) => {
          const updated = prev.filter((s) => s.id !== variantToDelete.id);
          return updated;
        });
      } else {
        setVariants((prev) => {
          const updated = prev.filter(v => v.id !== variantToDelete.id);
          return updated;
        });
      }
    }
    setVariantToDelete(null);
    setShowVariantDeleteModal(false);
  };

  const closeVariantDeleteModal = () => {
    setVariantToDelete(null);
    setShowVariantDeleteModal(false);
  };

  const buildVariantSourceObject = (sourceData, selectedChapters = [], selectedType = "") => {
    const chaptersToUse = selectedChapters.length > 0
      ? sourceData?.chapters?.filter(ch => selectedChapters.includes(ch.id))
      : [];

    const allQuestions = chaptersToUse.flatMap(ch =>
      (ch?.questions_list || []).filter(q => selectedType ? q.type === selectedType : true)
    );

    return {
      sourceId: sourceData.id,
      chapters: selectedChapters,
      questioncount: new Set(allQuestions.map(q => q.id)).size,
      questiontype: getTypeCounts(sourceData, selectedChapters, selectedType)
    };
  };

  const toggleVariantSource = (moduleId, level, sourceId) => {
    setVariants(prev =>
      prev.map(section => {
        if (section.id !== moduleId) return section;

        const selectedType = section.questionType || "";
        const sources = section.difficulties[level].sources;
        const exists = sources.find(s => s.sourceId === sourceId);

        if (exists) {
          return {
            ...section,
            difficulties: {
              ...section.difficulties,
              [level]: {
                ...section.difficulties[level],
                sources: sources.filter(s => s.sourceId !== sourceId)
              }
            }
          };
        }

        const sourceData = sourceList?.find(s => s.id === sourceId);
        if (!sourceData) return section;

        const newSource = buildVariantSourceObject(sourceData, [], selectedType);
        return {
          ...section,
          difficulties: {
            ...section.difficulties,
            [level]: {
              ...section.difficulties[level],
              sources: [...sources, newSource]
            }
          }
        };
      })
    );
    setErrors(prev => ({
      ...prev,
      variants: "",
      variantDetails: {
        ...prev?.variantDetails,
        [moduleId]: {
          ...prev?.variantDetails?.[moduleId],
          [level]: "",
        }
      }
    }));
  };

  const toggleVariantChapter = (moduleId, level, chapterId) => {
    setVariants(prev =>
      prev.map(section => {
        if (section.id !== moduleId) return section;
        const selectedType = section.questionType || "";
        return {
          ...section,
          difficulties: {
            ...section.difficulties,
            [level]: {
              ...section.difficulties[level],
              sources: section.difficulties[level].sources.map(src => {
                const sourceData = sourceList?.find(s => s.id === src.sourceId);
                if (!sourceData) return src;
                const belongs = sourceData?.chapters?.some(c => c.id === chapterId);
                if (!belongs) return src;

                const chapterExists = src.chapters.includes(chapterId);
                const updatedChapters = chapterExists
                  ? src.chapters.filter(id => id !== chapterId)
                  : [...src.chapters, chapterId];

                const filteredQuestionIds =
                  sourceData?.chapters
                    ?.filter(ch => updatedChapters.includes(ch.id))
                    ?.flatMap(ch =>
                      (ch?.questions_list || [])
                        .filter(q => (selectedType ? q.type === selectedType : true))
                        .map(q => q.id)
                    ) || [];
                return {
                  ...src,
                  chapters: updatedChapters,
                  questioncount: new Set(filteredQuestionIds).size,
                  questiontype: getTypeCounts(sourceData, updatedChapters, selectedType)
                };
              })
            }
          }
        };
      })
    );

    setErrors(prev => {
      const updatedVariantDetails = {
        ...prev?.variantDetails,
        [moduleId]: {
          ...prev?.variantDetails?.[moduleId],
          [level]: "",
        }
      };
      const anyVariantErrors = Object.values(updatedVariantDetails).some(
        v => Object.values(v).some(val => val !== "")
      );
      return {
        ...prev,
        variants: anyVariantErrors ? prev.variants : "",
        variantDetails: updatedVariantDetails
      };
    });
  };

  const updateVariant = (id, key, value) => {
    setVariants(prev => {
      const updated = prev.map(v => {
        if (v.id !== id) return v;
        const updatedVariant = { ...v, [key]: value };

        if (key === "questionperattempt") {
          updatedVariant.difficulties = {
            Easy: { ...v.difficulties.Easy, questionTypeDistribution: { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 } },
            Medium: { ...v.difficulties.Medium, questionTypeDistribution: { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 } },
            Hard: { ...v.difficulties.Hard, questionTypeDistribution: { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 } },
          };
        }
        if (key === "questionType") {
          const newDifficulties = {};
          ["Easy", "Medium", "Hard"].forEach(level => {
            const updatedSources = v.difficulties[level].sources.map(src => {
              const sourceData = sourceList?.find(s => s.id === src.sourceId);
              if (!sourceData) return src;
              const filteredQuestionIds = sourceData?.chapters?.filter(ch => src.chapters.includes(ch.id))?.flatMap(ch => (ch?.questions_list || []).filter(q => (value ? q.type === value : true)).map(q => q.id)) || [];
              return {
                ...src,
                questioncount: new Set(filteredQuestionIds).size,
                questiontype: getTypeCounts(sourceData, src.chapters, value)
              };
            });
            newDifficulties[level] = { ...v.difficulties[level], sources: updatedSources };
          });
          updatedVariant.difficulties = newDifficulties;
        }
        return updatedVariant;
      });
      return updated;
    });

    setErrors(prev => {
      const copy = { ...prev };
      if (copy?.variantDetails?.[id]) delete copy.variantDetails[id][key];
      delete copy.variants;
      return copy;
    });
  };

  useEffect(() => {
    getAssessmentTypeList();
    getAssessmentCategory();

    if (location?.state?.assessmentId) {
      getAssessmentDetails(location?.state?.assessmentId)
    }
  }, [])

  const getAssessmentTypeList = async () => {
    try {
      const result = await adminServices.getAssessmentTypeDropdown();
      if (result && result.ok) {
        const list = result.data?.data || result.data || [];
        setAssessmentTypeList(list.filter(item => item.is_active));
      }
    } catch (error) {
      console.error('Assessment Type dropdown API not ready:', error);
      setAssessmentTypeList([]);
    }
  };

  const getAssessmentDetails = async (id) => {
    const result = await adminServices.getAssessmentById(id)
    setAssessmentDetail(result.data)
  }

  const getAssessmentCategory = async () => {
    const result = await adminServices.getAssessmentCategory()
    setAssessmentCategory(result.data.data)
  }

  useEffect(() => {
    getassessmentscore()
  }, [])

  const getassessmentscore = async () => {
    const result = await adminServices.getassessmentscore(0, 10)
    setScoreDetails(result.data?.details?.data)
  }

  useEffect(() => {
    if (assessmentDetail) {
      setFormData({
        length: assessmentDetail?.assessment_type, batch: assessmentDetail?.batch_id, Subject: assessmentDetail?.subject_id, title: assessmentDetail?.title, description: assessmentDetail?.short_description, category: assessmentDetail?.type, duration: assessmentDetail?.time_in_mins, totalmarks: assessmentDetail?.total_marks
        , positivemarks: assessmentDetail?.positive_marks, negativemarks: assessmentDetail?.negative_marks, subcategory: assessmentDetail?.subcategory,internaltitle:assessmentDetail?.internaltitle
      });


      let rawSections = [];
      try {
        if (typeof assessmentDetail?.section_details === 'string' && assessmentDetail?.section_details?.trim()) {
          rawSections = JSON.parse(assessmentDetail?.section_details);
        } else if (Array.isArray(assessmentDetail?.section_details)) {
          rawSections = assessmentDetail?.section_details;
        }
      } catch (e) {
        rawSections = [];
      }
      const resetSections = rawSections?.map(section => ({
        ...section,
        questionTypeDistribution: section.questionTypeDistribution || { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 }
      }));
      setSections(resetSections);

      let rawVariants = [];
      try {
        if (typeof assessmentDetail?.variant_modules === 'string' && assessmentDetail?.variant_modules?.trim()) {
          rawVariants = JSON.parse(assessmentDetail?.variant_modules);
        } else if (Array.isArray(assessmentDetail?.variant_modules)) {
          rawVariants = assessmentDetail?.variant_modules;
        }
      } catch (e) {
        rawVariants = [];
      }
      const resetVariants = rawVariants?.map(variant => ({
        ...variant,
        difficulties: {
          Easy: {
            ...variant.difficulties?.Easy,
            questionTypeDistribution: variant.difficulties?.Easy?.questionTypeDistribution || { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 }
          },
          Medium: {
            ...variant.difficulties?.Medium,
            questionTypeDistribution: variant.difficulties?.Medium?.questionTypeDistribution || { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 }
          },
          Hard: {
            ...variant.difficulties?.Hard,
            questionTypeDistribution: variant.difficulties?.Hard?.questionTypeDistribution || { MCQ: 0, MCQ_MULTI: 0, PASSAGE_SINGLE: 0, PASSAGE_MULTI: 0, NUMERIC: 0 }
          }
        }
      }));
      setVariants(resetVariants);
      setBranchingConfig({ highThreshold: assessmentDetail?.branching_details?.highthreshold, lowThreshold: assessmentDetail?.branching_details?.lowthreshold, mediumRangeMin: assessmentDetail?.branching_details?.mediumrangemin, mediumRangeMax: assessmentDetail?.branching_details?.mediumrangemax });
      setBreakpages(assessmentDetail?.break_details ?? []);
      setBreakpage({ title: assessmentDetail?.break_details?.title, message: assessmentDetail?.break_details?.message });
      setShowBreakConfig(assessmentDetail?.break_details ? true : false);
      setAllowNavigation(assessmentDetail?.allownavigation);
      setAllowCalculator(assessmentDetail?.allowcalculator);
      if (assessmentDetail?.image_name) {
        setThumbPreview(assessmentDetail.image_name);
        setThumbImage(assessmentDetail.image_name);
      }
      const normalizedBreaks = {};
      if (assessmentDetail?.break_after_modules) {
        Object.entries(assessmentDetail.break_after_modules).forEach(([k, v]) => {
          normalizedBreaks[Number(k)] = v;
        });
      }
      setSectionBreaks(normalizedBreaks);
      if (assessmentDetail?.display_config) {
        setDisplayConfig(assessmentDetail.display_config);
      }
    }
  }, [assessmentDetail])
  const selectedAssessment = assessmentTypeList?.find(
    (item) => item.code === formData.category
  );

  const showBatch = selectedAssessment?.allow_learning_path;
  return (
    <>
      <div className="min-h-screen bg-gray-50 p-4 mt-12 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          <button id="back-to-assessments-btn" onClick={() => navigate('/app/assessments')} className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors mb-6">
            <ArrowLeft size={16} />
            {t('Back to Assessments')}
          </button>

          <div className="mb-5">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
              {isAdaptive ? t(`${location?.state?.assessmentId ? 'Edit' : 'Create'} Adaptive Assessment`) : t(`${location?.state?.assessmentId ? 'Edit' : 'Create'} Linear Assessment`)}
            </h1>
            <p className="text-sm sm:text-base text-gray-500 mt-1">
              {isAdaptive ? t('Dynamic branching based on learner accuracy') : t('Fixed question sequence, predictable flow')}
            </p>
          </div>
          <div className="flex gap-1 mb-6">
            <button id="tab-edit-btn" onClick={() => setActiveTab('edit')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors border ${activeTab === 'edit' ? 'bg-white border-gray-300 text-gray-900 shadow-sm' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
              {t('Edit Mode')}
            </button>

            <button id="tab-preview-btn" onClick={() => setActiveTab('preview')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors border ${activeTab === 'preview' ? 'bg-white border-gray-300 text-gray-900 shadow-sm' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
              {t('Preview Mode')}
            </button>
          </div>

          {isAdaptive && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
              <div className="flex items-start gap-3">
                <Info size={18} className="text-gray-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs sm:text-sm text-gray-700">
                  <span className="font-semibold">{t('Adaptive Branching:')}</span>{' '}
                  {t('Routes learners to Easy/Medium/Hard variants based on their accuracy in previous modules. Questions in each variant must match the variant\'s difficulty tag exactly.')}
                </p>
              </div>
            </div>
          )}
          {activeTab === "edit" &&
            <>
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6 lg:p-8 mb-6">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-6">{t('Basic Information')} </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-2">
                  <div>
                    <label htmlFor="assessment-category" className="block text-sm font-medium text-gray-900 mb-1.5">
                      {t('Assessment Length')} <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <select id="assessment-length"
                        name="length" disabled={assessmentDetail}
                        value={formData.length || ""}
                        onChange={handleChange}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white appearance-none cursor-pointer pr-10 transition-shadow">
                        <option value="" disabled>
                          Select assessment type
                        </option>
                        {!isAdaptive && <option value="Chapter Test">{t("Chapter Test")}</option>}
                        <option value="Full Test">{t("Full Test")}</option>
                        <option value="Subject Test">{t("Subject Test")}</option>
                      </select>
                      <svg className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" width="16" height="16" viewBox="0 0 20 20" fill="none">
                        <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    {errors.length && (<p className="text-red-500 text-xs mt-1">{errors.length}</p>)}
                  </div>

                  <div>
                    <label htmlFor="assessment-category" className="block text-sm font-medium text-gray-900 mb-1.5">
                      {t('Category')} <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <select disabled={assessmentDetail} id="assessment-category"
                        name="category" value={formData.category || ""}
                        onChange={handleChange}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white appearance-none cursor-pointer pr-10 transition-shadow"
                      >
                        <option value="" disabled>{t("Select Category")}</option>
                        {assessmentTypeList && assessmentTypeList?.length > 0 && assessmentTypeList.map((item) => (
                          <option key={item.id} value={item.code}>
                            {t(item.code)}
                          </option>
                        ))}
                      </select>
                      <svg className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" width="16" height="16" viewBox="0 0 20 20" fill="none">
                        <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>

                   <div>
                      <label htmlFor="assessment-internaltitle" className="block text-sm font-medium text-gray-900 mb-2">{t("Internal Name")} <span className="text-red-500">*</span></label>
                      <input id="assessment-internaltitle" type="text" name="internaltitle" value={formData.internaltitle} onChange={handleChange} placeholder={isAdaptive ? t("e.g., Adaptive Physics Test") : t("e.g., NEET Physics Mock Test 1")}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" />
                      {errors.internaltitle && (<p className="text-red-500 text-xs mt-1">{errors.internaltitle}</p>)}
                    </div>
                </div>

                <div className="space-y-5">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div>
                      <label htmlFor="assessment-title" className="block text-sm font-medium text-gray-900 mb-2">{t("Display Name")} <span className="text-red-500">*</span></label>
                      <input id="assessment-title" type="text" name="title" value={formData.title} onChange={handleChange} placeholder={isAdaptive ? t("e.g., Adaptive Physics Test") : t("e.g., NEET Physics Mock Test 1")}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent" />
                      {errors.title && (<p className="text-red-500 text-xs mt-1">{errors.title}</p>)}
                    </div>

                    <div><label htmlFor="assessment-category" className="block text-sm font-medium text-gray-900 mb-2">{t("Sub Category")}</label>

                      <div className="relative">
                        <select id="assessment-sub-category" disabled={!formData.category} name="subcategory" value={formData.subcategory || ""} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-500 pr-10">
                          <option value="" disabled>
                            {t("Select Sub Category")}
                          </option>

                          {assessmentSubType?.map((item) => (
                            <option key={item.id} value={item.name}>
                              {t(item.name)}
                            </option>
                          ))}
                        </select>

                        <svg
                          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400"
                          width="16"
                          height="16"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M6 8l4 4 4-4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>

                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

                    {formData.length !== 'Full Test' &&
                      <div>
                        <label htmlFor="Subject" className="block text-sm font-medium text-gray-900 mb-1.5">{t('Subject')} <span className="text-red-500">*</span></label>
                        <div className="relative">
                          <select id="Subject" name="Subject" value={formData.Subject || ""}
                            onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white appearance-none cursor-pointer pr-10 transition-shadow">
                            <option value="" disabled>{t("Select Subject")}</option>
                            {subjects && subjects?.length > 0 && subjects?.map((item) => (
                              <option key={item.id} value={item.id}>{t(item.name)}</option>
                            ))}
                          </select>
                          <svg className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" width="16" height="16" viewBox="0 0 20 20" fill="none">
                            <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                        {errors.length && (<p className="text-red-500 text-xs mt-1">{errors.length}</p>)}
                      </div>}

                    {showBatch && <div>
                      <label htmlFor="assessment-category" className="block text-sm font-medium text-gray-900 mb-1.5">{t('Batch')} <span className="text-red-500">*</span></label>
                      {/* <div className="relative">
                        <select id="batch" name="batch" value={formData.batch || ""}
                          onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white appearance-none cursor-pointer pr-10 transition-shadow">
                          <option value="" disabled>{t("Select Assessment Batch")}</option>
                          {assessmentCategory && assessmentCategory?.length > 0 && assessmentCategory?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {t(item.name)}
                            </option>
                          ))}
                        </select>
                        <svg className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" width="16" height="16" viewBox="0 0 20 20" fill="none">
                          <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div> */}

                      <div className="relative" id="batch">

                        <button
                          type="button"
                          onClick={() => setIsBatchOpen((prev) => !prev)}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg
               text-sm focus:outline-none focus:ring-2
               focus:ring-purple-500 focus:border-transparent
               bg-white cursor-pointer flex items-center
               justify-between text-left"
                        >
                          <span className="truncate">
                            {formData.batch?.length > 0
                              ? assessmentCategory
                                ?.filter((item) =>
                                  formData.batch.includes(Number(item.id))
                                )
                                .map((item) => t(item.name))
                                .join(", ")
                              : t("Select Assessment Batch")}
                          </span>

                          <svg
                            className={`text-gray-400 transition-transform ${isBatchOpen ? "rotate-180" : ""
                              }`}
                            width="16"
                            height="16"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M6 8l4 4 4-4"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>

                        {isBatchOpen && (
                          <div
                            className="absolute z-50 mt-1 w-full bg-white
                 border border-gray-200 rounded-lg shadow-lg"
                          >
                            <div
                              className="max-h-40 overflow-y-auto p-2 space-y-1"
                              style={{ scrollbarWidth: "thin" }}
                            >
                              {assessmentCategory?.length === 0 && (
                                <p className="text-sm text-gray-400 px-2 py-1">
                                  Loading Batches...
                                </p>
                              )}

                              {assessmentCategory?.length > 0 &&
                                assessmentCategory.map((item) => {
                                  const value = Number(item.id);

                                  const isSelected = (formData.batch || []).includes(value);


                                  return (
                                    <label
                                      key={item.id}
                                      className={`flex items-center gap-2 px-2 py-2
                            rounded cursor-pointer text-sm
                            hover:bg-gray-50 ${isSelected ? "bg-purple-50" : ""
                                        }`}
                                    >
                                      <input
                                        type="checkbox"
                                        value={value}
                                        checked={isSelected}
                                        onChange={() =>
                                          handleAssessmentTypeToggle(value)
                                        }
                                        className="w-4 h-4 rounded border-gray-300
                             text-purple-600 focus:ring-purple-500"
                                      />

                                      <span className="text-gray-800">
                                        {t(item.name)}
                                      </span>
                                    </label>
                                  );
                                })}
                            </div>

                            {formData.batch?.length > 0 && (
                              <>
                                <div className="border-t border-gray-100 px-3 py-2 flex justify-between items-center">
                                  <span className="text-xs text-gray-500">
                                    {formData.batch.length} selected
                                  </span>

                                  <button type="button" onClick={() => setFormData((prev) => ({ ...prev, batch: [] }))} className="text-xs text-purple-600 hover:text-purple-700" >Clear </button>
                                  <button type="button" onClick={() => setIsBatchOpen(false)} className="text-xs text-purple-600 hover:text-purple-700">Save</button>
                                </div>

                              </>
                            )}
                          </div>
                        )}
                      </div>


                      {errors.length && (<p className="text-red-500 text-xs mt-1">{errors.length}</p>)}
                    </div>}

                    <div>
                      <label htmlFor="assessment-duration" className="block text-sm font-medium text-gray-900 mb-1.5"> {t('Duration (minutes)')} <span className="text-red-500">*</span></label>
                      <input id="assessment-duration" type="number" name="duration" step="1" value={formData.duration} min="1" onKeyDown={(e) => { if (e.key === '-' || e.key === '.') e.preventDefault(); }}
                        onChange={(e) => { const value = e.target.value === '' ? '' : Math.floor(Number(e.target.value)); if (value !== '' && Number(value) < 1) return; setFormData(prev => ({ ...prev, duration: value })); setErrors(prev => ({ ...prev, duration: '' })); }}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow" />
                      {errors.duration && (<p className="text-red-500 text-xs mt-1">{errors.duration}</p>)}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    <div>
                      <label htmlFor="assessment-duration" className="block text-sm font-medium text-gray-900 mb-1.5"> {t('Positive Marks')} <span className="text-red-500">*</span></label>
                      <input id="assessment-positivemarks" type="number" name="positivemarks" step="1" value={formData.positivemarks} min="1" onKeyDown={(e) => { if (e.key === '-' || e.key === '.') e.preventDefault(); }}
                        onChange={(e) => { const value = e.target.value === '' ? '' : Math.floor(Number(e.target.value)); if (value !== '' && Number(value) < 1) return; setFormData(prev => ({ ...prev, positivemarks: value })); setErrors(prev => ({ ...prev, positivemarks: '' })); }}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow"
                      />
                      {errors.positivemarks && (<p className="text-red-500 text-xs mt-1">{errors.positivemarks}</p>)}
                    </div>

                    <div>
                      <label htmlFor="assessment-totalmarks" className="block text-sm font-medium text-gray-900 mb-1.5"> {t('Negative Marks')} <span className="text-red-500">*</span></label>
                      <input id="assessment-negativemarks" type="number" name="negativemarks" step="1" min="0" value={formData.negativemarks} onKeyDown={(e) => { if (e.key === '-') { e.preventDefault(); } }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '') {
                            setFormData((prev) => ({
                              ...prev,
                              negativemarks: ''
                            }));
                            return;
                          }
                          const numValue = Number(value);
                          if (numValue < 0) return;
                          setFormData((prev) => ({ ...prev, negativemarks: value }));
                          setErrors((prev) => ({ ...prev, negativemarks: '' }));
                        }}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow"
                      />

                      {errors.negativemarks && (<p className="text-red-500 text-xs mt-1">{errors.negativemarks}</p>)}
                    </div>

                    <div>
                      <label htmlFor="assessment-totalmarks" className="block text-sm font-medium text-gray-900 mb-1.5"> {t('Total Marks')} <span className="text-red-500">*</span></label>
                      <input id="assessment-totalmarks" type="number" name="totalmarks" step="1" value={formData.totalmarks} min="0" onKeyDown={(e) => { if (e.key === '-' || e.key === '.') { e.preventDefault(); } }}
                        onChange={(e) => { const value = e.target.value === '' ? '' : Math.floor(Number(e.target.value)); if (value !== '' && Number(value) < 0) return; setFormData((prev) => ({ ...prev, totalmarks: value })); setErrors((prev) => ({ ...prev, totalmarks: '' })); }}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow" />
                      {errors.totalmarks && (<p className="text-red-500 text-xs mt-1">{errors.totalmarks}</p>)}
                    </div>
                  </div>
                  {!isAdaptive && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div className="flex items-center gap-3">
                        <span className="text-sm font-medium text-gray-900">{t('Allow Navigation')}</span>
                        <button
                          id="allow-navigation-toggle"
                          type="button"
                          onClick={() => setAllowNavigation(prev => !prev)}
                          className={`relative w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${allowNavigation ? 'bg-gray-900' : 'bg-gray-300'}`}
                        >
                          <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${allowNavigation ? 'translate-x-5' : 'translate-x-0'}`} />
                        </button>
                      </div>

                      <div className="flex items-center gap-3">
                        <span className="text-sm font-medium text-gray-900">{t('Allow Calculator')}</span>
                        <button
                          id="allow-calculator-toggle"
                          type="button"
                          onClick={() => setAllowCalculator(prev => !prev)}
                          className={`relative w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${allowCalculator ? 'bg-gray-900' : 'bg-gray-300'}`}
                        >
                          <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${allowCalculator ? 'translate-x-5' : 'translate-x-0'}`} />
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {isAdaptive && (
                  <>
                    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 sm:p-6 lg:p-8 mb-6 mt-4">
                      <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{t('Branching Configuration')}</h2>
                      <p className="text-xs sm:text-sm text-gray-500 mb-6">{t('Routing is based on accuracy = correctAnswers / totalQuestions.')}</p>
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                        <div>
                          <label htmlFor="high-threshold" className="block text-sm font-medium text-gray-900 mb-1.5">{t('High Threshold (%) - Hard Variant')}</label>
                          <input id="high-threshold" type="number" name="highThreshold" value={branchingConfig.highThreshold} onChange={handleBranchingChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow" />
                          <p className="text-xs text-gray-500 mt-1.5">{t('If accuracy ≥ 70%')}</p>
                        </div>

                        <div>
                          <label htmlFor="low-threshold" className="block text-sm font-medium text-gray-900 mb-1.5">{t('Low Threshold (%) - Easy Variant')}</label>
                          <input id="low-threshold" type="number" name="lowThreshold" value={branchingConfig.lowThreshold} onChange={handleBranchingChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow" />
                          <p className="text-xs text-gray-500 mt-1.5">{t('If accuracy < 40%')}</p>
                        </div>
                        <div>
                          <div className="block text-sm font-medium text-gray-900 mb-1.5">{t('Medium Range')}</div>
                          <div className="flex items-center gap-2">
                            <label htmlFor="medium-range-min" className="sr-only">{t('Medium Range Minimum')}</label>
                            <input id="medium-range-min" name='mediumRangeMin' type="number" value={branchingConfig.mediumRangeMin} onChange={handleBranchingChange} aria-label={t('Medium Range Minimum')} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm bg-gray-50 text-gray-500" />
                            <span className="text-gray-400">-</span>
                            <label htmlFor="medium-range-max" className="sr-only">{t('Medium Range Maximum')}</label>
                            <input id="medium-range-max" name='mediumRangeMax' type="number" value={branchingConfig.mediumRangeMax} onChange={handleBranchingChange} aria-label={t('Medium Range Maximum')} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm bg-gray-50 text-gray-500" />
                          </div>
                          <p className="text-xs text-gray-500 mt-1.5">{t('Medium variant (calculated)')}</p>
                        </div>
                      </div>

                      <div className="mt-6">
                        <button id="reset-branching-config-btn" type="button" onClick={handleResetConfig} className="text-sm text-gray-600 hover:text-gray-900 underline transition-colors">{t('Reset to Default (70% / 40%)')} </button>
                      </div>
                    </div>
                    {errors.branch && (<p className="text-red-500 text-xs mt-1">{errors.branch}</p>)}
                  </>
                )}

                <div>
                  <label htmlFor="assessment-description" className="block text-sm font-medium text-gray-900 mb-1.5 mt-1.5">{t('Description')}</label>
                  <textarea id="assessment-description" name="description"
                    value={formData.description} onChange={handleChange}
                    rows={4} placeholder={isAdaptive ? t('Assessment description...') : t('Brief description of the assessment...')}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-shadow resize-y placeholder-gray-400" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-1.5">
                    Thumb Image*
                    <span className="text-xs text-gray-400 ml-1">(min 360×200, max 2MB)</span>
                  </label>
                  {!thumbPreview ? (
                    <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 transition">
                      <span className="text-sm text-gray-500">Click to upload or drag and drop</span>
                      <span className="text-xs text-gray-400 mt-1">JPG, PNG, BMP</span>
                      <input id="thumb-image-upload" type="file" accept="image/jpeg,image/png,image/bmp" className="hidden" onChange={handleThumbFileChange} />
                    </label>
                  ) : (
                    <div className="relative inline-block">
                      <img src={thumbPreview} alt="Thumb preview" className="h-32 rounded-lg object-cover border border-gray-200" />
                      <button id="remove-thumb-image-btn" type="button" onClick={() => { setThumbPreview(null); setThumbImage(null); }} className="absolute top-1 right-1 bg-white rounded-full p-0.5 shadow text-red-500 hover:text-red-700 text-xs">✕ </button>
                    </div>
                  )}
                  {thumbImageError && <p className="text-red-500 text-xs mt-1">{thumbImageError}</p>}
                  {errors.thumbImage && <p className="text-red-500 text-xs mt-1">{errors.thumbImage}</p>}
                </div>
                <div className="p-6 bg-gray-50 mt-4">
                  <div className="flex justify-between mb-4">
                    <div>
                      <h2 className="text-xl font-semibold">{!isAdaptive ? "Sections & Questions Pools" : "Modules & Questions Pools"}</h2>
                    </div>
                    {!isAdaptive ?
                      <button id="add-section-btn" onClick={addSection} disabled={!formData?.length} className={`px-4 py-2 rounded-lg text-white transition ${!formData?.length ? "bg-gray-400 cursor-not-allowed" : "bg-black hover:bg-gray-800"}`}>+ Add Section</button>
                      :
                      <>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                          <button id="add-foundation-module-btn" disabled={!formData?.length} onClick={addSection} type="button" className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${!formData?.length ? "bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed" : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}>
                            {t("+ Foundation Module")}
                          </button>
                          <button id="add-variant-module-btn" disabled={!formData?.length} onClick={addVariantModule} type="button" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${!formData?.length ? "bg-gray-300 text-gray-400 cursor-not-allowed" : "text-white bg-gray-900 hover:bg-gray-800"}`}>
                            {t("+ Variant Module")}
                          </button>
                        </div>
                      </>}
                  </div>

                  {sections?.length === 0 && (
                    <div className="flex items-center justify-center py-16 border-2 border-dashed border-gray-200 rounded-lg">
                      <div className="text-center">
                        <p className="text-sm text-gray-400 mb-6">{t('Please select Assessment Length first to configure modules.')}</p>
                        {!isAdaptive ? <button id="add-section-btn" onClick={addSection} disabled={!formData?.length} className={`px-4 py-2 rounded-lg text-white transition ${!formData?.length ? "bg-gray-400 cursor-not-allowed" : "bg-black hover:bg-gray-800"}`}>+ Add Section</button>
                          :
                          <div className="flex flex-col sm:flex-row gap-3 justify-center">
                            <button disabled={!formData?.length} onClick={addSection} type="button" className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${!formData?.length ? "bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed" : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"}`}>
                              {t("+ Foundation Module")}
                            </button>
                            <button onClick={addVariantModule} disabled={!formData?.length} type="button" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${!formData?.length ? "bg-gray-300 text-gray-400 cursor-not-allowed" : "text-white bg-gray-900 hover:bg-gray-800"}`}>
                              {t("+ Variant Module")}
                            </button>
                          </div>}
                      </div>
                    </div>
                  )}
                  {sections && sections.length > 0 && sections.map((section, index) => {
                    const selectedSourceIds = section.sources.map(s => s.sourceId);
                    const filteredChapters = selectedSourceIds?.length ? sourceList?.filter(src => selectedSourceIds.includes(src.id))?.flatMap(src => src.chapters || []) : [];
                    const sectionErr = errors?.sectionDetails?.[section.id] || {};
                    let totalQuestions = 0
                    if (isAdaptive) {
                      totalQuestions = section?.sources?.reduce((sum, src) => {
                        const chapterList = src.chapters ?? src.chapter_ids ?? [];
                        if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
                        return sum + (Number(src.questioncount) || 0);
                      }, 0);
                    }
                    else {
                      totalQuestions = section?.sources?.reduce((sum, src) => {
                        const chapterList = src.chapters ?? src.chapter_ids ?? [];
                        if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
                        const questionTypeCounts = src.questiontype || {};
                        const count = Object.values(questionTypeCounts).reduce(
                          (a, b) => a + (Number(b) || 0),
                          0
                        );
                        return sum + count;
                      }, 0);
                    }
                    const distributedTotal = Object.values(section.questionTypeDistribution || {}).reduce((sum, v) => sum + Number(v || 0), 0);
                    const distributionTarget = Number(section.questionperattempt || 0);
                    const isDistributionComplete = distributionTarget > 0 && distributedTotal >= distributionTarget;
                    const QUESTION_TYPE_LABELS = {
                      MCQ: "MCQ (Single)",
                      MCQ_MULTI: "MCQ (Multiple)",
                      PASSAGE_SINGLE: "Passage (Single)",
                      PASSAGE_MULTI: "Passage (Multi)",
                      NUMERIC: "Numeric",
                    };

                    return (
                      <React.Fragment key={section.id}>
                        <div className={`bg-white rounded-xl border p-6 ${index !== sections.length - 1 ? "mb-6" : ""}`}>
                          <div className="flex items-end gap-4 mb-6 w-full">
                            <div className="flex-1 min-w-[220px]">
                              <label className="block text-sm mb-1">{isAdaptive ? 'Module' : 'Section'} Name</label>
                              <input id={`section-name-input-${section.id}`} type="text" value={section.name} onChange={(e) => updateSection(section.id, "name", e.target.value)}
                                className={`w-full px-4 py-2 rounded-lg outline-none ring-2 ${sectionErr.name ? "border-red-400 ring-red-300" : "border-gray-300 ring-gray-500"}`} />
                              {sectionErr.name && (<p className="text-xs text-red-500 mt-1">{sectionErr.name}</p>)}
                            </div>
                            <div className="w-[140px]">
                              <label className="block text-sm mb-1">Time (minutes)</label>
                              <input id={`section-time-input-${section.id}`} type="number" value={section.time} onChange={(e) => updateSection(section.id, "time", e.target.value)}
                                className={`w-full px-4 py-2 rounded-lg outline-none ring-2 ${sectionErr.time ? "border-red-400 ring-red-300" : "border-gray-300 ring-gray-500"}`} />
                            </div>
                            {isAdaptive && (
                              <>
                                <div className="w-[220px]">
                                  <label className="block text-sm mb-1">Select Score Template</label>
                                  <select className={`w-full px-4 py-2 rounded-lg outline-none ring-2 ${sectionErr.scoretemplate ? "border-red-400 ring-red-300" : "border-gray-300 ring-gray-500"}`} value={section.scoretemplate || ""}
                                    onChange={(e) => updateSection(section.id, "scoretemplate", e.target.value)}>
                                    <option value="" disabled> Select Template</option>
                                    {scoreDetails?.map((data) => (
                                      <option key={data.id} value={data.id}>
                                        {data.template_name}
                                      </option>
                                    ))}
                                  </select>
                                  {sectionErr.scoretemplate && (<p className="text-xs text-red-500 mt-1">{sectionErr.scoretemplate}</p>)}
                                </div>

                                <div className="w-[180px]">
                                  <label className="block text-sm mb-1">Question Type</label>
                                  <select className="w-full px-4 py-2 rounded-lg outline-none ring-2 border-gray-300 ring-gray-500" value={section.questionType} onChange={(e) => updateSection(section.id, "questionType", e.target.value)}>
                                    <option value="MCQ">MCQ</option>
                                    <option value="PASSAGE_SINGLE">Passage Single</option>
                                  </select>
                                </div>
                              </>
                            )}

                            <div className="flex items-center">
                              <button id={`remove-section-btn-${section.id}`} onClick={() => removeSection(section.id)} className="border p-2 rounded text-red-500"><Trash2 className="w-5 h-5" /></button>
                            </div>
                          </div>

                          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
                            <div>
                              <div className="flex justify-between mb-2">
                                <label className="font-medium">Sources *</label>
                                <div className="flex gap-3 text-sm">
                                  {/* <button id={`select-all-sources-btn-${section.id}`} onClick={() => selectAllSources(section.id)} className="px-3 py-1 rounded hover:bg-gray-200 transition" >Select All</button> */}
                                  <button id={`deselect-all-sources-btn-${section.id}`} onClick={() => deselectAllSources(section.id)} className="px-3 py-1 rounded hover:bg-gray-200 transition" > Deselect All  </button>
                                </div>
                              </div>
                              <SourceBox title="" data={sourceList} selected={section.sources.map(s => s.sourceId)} onToggle={(v) => toggleArray(section.id, "sources", v)} />
                              {sectionErr.sources && <p className="text-xs text-red-500 mt-1">{sectionErr.sources}</p>}
                            </div>

                            <div>
                              <div className="flex justify-between mb-2">
                                <label className="font-medium">Chapters *</label>
                                {!isAdaptive && (
                                  <div className="flex gap-3 text-sm">
                                    <button id={`deselect-all-chapters-btn-${section.id}`} className="px-3 py-1 rounded hover:bg-gray-200 transition" onClick={() => deselectAllChapters(section.id)}>Deselect All</button>
                                  </div>)}
                              </div>
                              <ChapterBox title="" data={filteredChapters} selected={section.sources.flatMap(s => s.chapters)} onToggle={(v) => toggleArray(section.id, "chapters", v)} />
                              {sectionErr.chapters && <p className="text-xs text-red-500 mt-1">{sectionErr.chapters}</p>}
                            </div>
                          </div>

                          <div className="flex gap-4">
                            {!isAdaptive && (
                              <>
                                <div className="flex flex-col gap-1">
                                  <label className="text-sm font-medium text-gray-900"> Difficulty </label>
                                  <select id={`section-difficulty-select-${section.id}`} className="w-80 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    value={section.difficulty} onChange={(e) => updateSection(section.id, "difficulty", e.target.value)}>
                                    <option value="">Select difficulty</option>
                                    <option value="Easy">Easy</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Hard">Hard</option>
                                  </select>
                                  {sectionErr.difficulty && <p className="text-xs text-red-500 mt-1">{sectionErr.difficulty}</p>}
                                </div>
                              </>
                            )}
                            <div>
                              <label className="block text-sm font-medium mb-1">Questions Per Attempt *</label>
                              <input id={`section-qpa-input-${section.id}`} type="number" min="1" value={section?.questionperattempt} onKeyDown={(e) => { if (e.key === '-' || e.key === 'e' || e.key === '.') e.preventDefault(); }}
                                onChange={(e) => { const value = e.target.value; if (value !== '' && Number(value) < 1) return; updateSection(section.id, "questionperattempt", value) }}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                              />
                              {sectionErr.questionperattempt && (<p className="text-xs text-red-500 mt-1">{sectionErr.questionperattempt}</p>)}
                              <p className="text-xs text-gray-500 mt-1"> Number of questions to select from pool for each learner attempt</p>
                            </div>
                          </div>
                        </div>

                        <div className="rounded-lg border border-red-300 bg-red-50 p-4 mt-4 mb-4">
                          <div className="flex items-start gap-2 text-red-700">
                            <div className="mt-0.5">
                              <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" />
                                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" />
                                <circle cx="12" cy="16" r="1" fill="currentColor" />
                              </svg>
                            </div>
                            <div className="flex-1">
                              <p className="text-sm font-medium">Questions in Sources & Chapters must be greater than Questions per attempt</p>
                              <div className="mt-3 flex gap-3">
                                <span className="px-3 py-1 text-sm rounded-md bg-gray-100 border border-gray-300 text-gray-700">Total: {totalQuestions} </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-gray-50 rounded-xl border p-5 mt-4">
                          <div className="flex justify-between items-center mb-4">
                            <h3 className="font-semibold text-gray-800"> Question Type Distribution </h3>
                          </div>
                          {Object.keys(QUESTION_TYPE_LABELS).map((typeKey) => {
                            const available = section?.sources?.reduce((total, src) => { return total + (src?.questiontype?.[typeKey] || 0); }, 0) || 0;
                            const selected = section?.questionTypeDistribution?.[typeKey] || 0;
                            return (
                              <div key={typeKey} className="flex justify-between items-center border-b py-3">
                                <span className="text-gray-700"> {QUESTION_TYPE_LABELS[typeKey]} </span>
                                <div className="flex items-center gap-4">
                                  <span className="text-sm text-gray-500"> {available} available </span>
                                  <input id={`section-dist-input-${section.id}-${typeKey}`} type="number" value={selected} min={0} max={available} onKeyDown={(e) => { if (e.key === '-' || e.key === 'e' || e.key === '.') e.preventDefault(); }} onChange={(e) => updateQuestionTypeDistribution(section.id, typeKey, e.target.value, available)}
                                    className="w-20 border border-gray-300 rounded-md px-2 py-1 text-center" />
                                </div>
                              </div>
                            );
                          })}
                          <div className={`flex justify-between items-center mt-4 border rounded-md px-4 py-2 ${isDistributionComplete ? "bg-green-50 border-green-300" : "bg-red-50 border-red-300"}`}>
                            <span className={`font-medium text-sm ${isDistributionComplete ? "text-green-700" : "text-red-600"}`}>
                              {isDistributionComplete ? "✓ All questions distributed" : `${distributionTarget - distributedTotal} questions not yet allocated`}
                            </span>
                            <span className="text-sm font-medium text-gray-700">
                              {distributedTotal} / {distributionTarget}
                            </span>
                          </div>
                          {sectionErr.questionDistribution && (
                            <p className="text-red-500 text-xs mt-2">{sectionErr.questionDistribution}</p>
                          )}
                        </div>
                      </React.Fragment>
                    );
                  })}
                  {errors.sections && (<p className="text-red-500 text-xs mt-1">{errors.sections}</p>)}
                </div>
              </div>

              {variants && variants?.length > 0 && variants?.map((section, index) => {
                const variantErr = errors?.variantDetails?.[section.id] || {};
                const activeSources = section.difficulties[activeVariantDifficulty].sources;
                const selectedSourceIds = activeSources.map(s => s.sourceId);
                const normalizedDifficulty = activeVariantDifficulty.toLowerCase();
                const filteredSources = sourceList?.filter(src => src.complexity_level?.toLowerCase() === normalizedDifficulty);
                const filteredChapters = selectedSourceIds?.length ? filteredSources?.filter(src => selectedSourceIds.includes(src.id))?.flatMap(src => src.chapters || []) : [];
                const totalQuestions = section.difficulties?.[activeVariantDifficulty]?.sources?.reduce((sum, src) => {
                  const chapterList = src.chapters ?? src.chapter_ids ?? [];
                  if (!Array.isArray(chapterList) || chapterList.length === 0) return sum;
                  return sum + (Number(src.questioncount) || 0);
                }, 0) || 0;
                const QUESTION_TYPE_LABELS = {
                  MCQ: "MCQ (Single)",
                  MCQ_MULTI: "MCQ (Multiple)",
                  PASSAGE_SINGLE: "Passage (Single)",
                  PASSAGE_MULTI: "Passage (Multi)",
                  NUMERIC: "Numeric",
                };
                const selectedDistribution = section.difficulties?.[activeVariantDifficulty]?.questionTypeDistribution || {};
                const totalSelected = Object.values(selectedDistribution).reduce((sum, val) => sum + Number(val || 0), 0);
                const activeQuestionType = section.questionType || "";

                const variantSeenQuestionIds = new Set();
                const questionTypeCounts = activeSources.reduce((acc, src) => {
                  const selectedChapters = src.chapters ?? src.chapter_ids ?? [];
                  if (!selectedChapters.length) return acc;
                  const sourceData = sourceList?.find(s => s.id === src.sourceId);
                  if (!sourceData) return acc;
                  const chaptersToCount = sourceData.chapters?.filter(ch => selectedChapters.includes(ch.id)) || [];
                  chaptersToCount.forEach(ch => {
                    (ch.questions_list || []).forEach(q => {
                      if (activeQuestionType && q.type !== activeQuestionType) return;
                      // dedupe: a question shared across chapters counts once
                      if (variantSeenQuestionIds.has(q.id)) return;
                      variantSeenQuestionIds.add(q.id);
                      acc[q.type] = (acc[q.type] || 0) + 1;
                    });
                  });
                  return acc;
                }, {}) || {};

                const variantDistTarget = Number(section.questionperattempt || 0);
                const isVariantDistComplete = variantDistTarget > 0 && totalSelected >= variantDistTarget;

                return (
                  <>
                    <div key={section.id} className="bg-white rounded-xl border p-6 mb-6 mt-6">
                      <div><h2 className="text-xl font-semibold">Variant Modules & Questions Pools</h2></div>
                      <div className="grid grid-cols-12 gap-4 mb-4 mt-4">
                        <div className="col-span-4">
                          <label>Variant Name</label>
                          <input id={`variant-name-input-${section.id}`} value={section.name} onChange={(e) => updateVariant(section.id, "name", e.target.value)} className="ml-2 border rounded px-4 py-2 w-full" />
                          {variantErr.name && (<p className="text-xs text-red-500 mt-1">Variant {index + 1}: {variantErr.name}</p>)}
                        </div>

                        <div className="col-span-3">
                          <label>Time (minutes)</label>
                          <input id={`variant-time-input-${section.id}`} type="number" step="1" value={section.time} onKeyDown={(e) => { if (e.key === '-' || e.key === '.') e.preventDefault(); }}
                            onChange={(e) => { const value = e.target.value === '' ? '' : Math.floor(Number(e.target.value)); if (value !== '' && Number(value) < 1) return; updateVariant(section.id, "time", value); }} className="ml-2 border rounded px-4 py-2 w-full" />
                          {variantErr.time && (<p className="text-xs text-red-500 mt-1">Variant {index + 1}: {variantErr.time}</p>)}
                        </div>

                        <div className="col-span-3">
                          <label>Question Type</label>
                          <select id={`variant-question-type-select-${section.id}`} className="ml-2 input px-4 py-2 rounded-lg outline-none ring-2 border-gray-300 ring-gray-500 w-full" value={section.questionType} onChange={(e) => updateVariant(section.id, "questionType", e.target.value)} >
                            <option value="MCQ">MCQ</option>
                            <option value="PASSAGE_SINGLE">Passage Single</option>
                          </select>
                        </div>
                        <div className="col-span-2 flex justify-end">
                          <button id={`remove-variant-btn-${section.id}`} onClick={() => { setVariantToDelete({ id: section.id, type: 'variant' }); setShowVariantDeleteModal(true); }} className="text-red-500"><Trash2 className="w-5 h-5" /></button>
                        </div>
                      </div>

                      <div className="inline-flex bg-gray-100 rounded-xl p-1 mb-5">
                        {["Easy", "Medium", "Hard"].map(level => {
                          const isActive = activeVariantDifficulty === level;
                          const activeColors = {
                            Easy: "bg-green-100 text-black shadow-sm",
                            Medium: "bg-yellow-100 text-black shadow-sm",
                            Hard: "bg-red-100 text-black shadow-sm"
                          };
                          return (
                            <button key={level} id={`variant-difficulty-tab-${section.id}-${level}`} onClick={() => setActiveVariantDifficulty(level)} className={`px-6 py-2 text-sm font-semibold rounded-lg transition-all duration-200 ${isActive ? activeColors[level] : "text-gray-600 hover:text-black"}`} >{level.toUpperCase()} </button>
                          );
                        })}
                      </div>

                      {variantErr[activeVariantDifficulty]?.includes('chapter') && (<p className="text-xs text-red-500 mt-1">{variantErr[activeVariantDifficulty]}</p>)}
                      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-6">
                        <div>
                          <SourceBox data={filteredSources} selected={activeSources.map(s => s.sourceId)} onToggle={(v) => toggleVariantSource(section.id, activeVariantDifficulty, v)} />
                        </div>
                        <div>
                          <ChapterBox data={filteredChapters} selected={activeSources.flatMap(s => s.chapters)} onToggle={(v) => toggleVariantChapter(section.id, activeVariantDifficulty, v)} />
                          {variantErr[activeVariantDifficulty]?.includes('chapter') && (<p className="text-xs text-red-500 mt-1">{variantErr[activeVariantDifficulty]}</p>)}
                        </div>
                      </div>
                      <div>
                        <label>Questions Per Attempt</label>
                        <input id={`variant-qpa-input-${section.id}`} type="number" min="1" value={section.questionperattempt}
                          onKeyDown={(e) => { if (e.key === '-' || e.key === 'e' || e.key === '.') e.preventDefault(); }}
                          onChange={(e) => { const value = e.target.value; if (value !== '' && Number(value) < 1) return; updateVariant(section.id, "questionperattempt", value); }} className="border rounded px-3 py-2 ml-2" />
                        {variantErr.questionperattempt && (<p className="text-xs text-red-500 mt-1"> Variant {index + 1}: {variantErr.questionperattempt}</p>)}
                      </div>
                    </div>

                    <div className="rounded-lg border border-red-300 bg-red-50 p-4 mt-4 mb-4">
                      <div className="flex items-start gap-2 text-red-700">
                        <div className="mt-0.5">
                          <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" />
                            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" />
                            <circle cx="12" cy="16" r="1" fill="currentColor" />
                          </svg>
                        </div>
                        <div className="flex-1">
                          <p className="text-sm font-medium">Questions in Sources & Chapters must be greater than Questions per attempt</p>
                          <div className="mt-3 flex gap-3">
                            <span className="px-3 py-1 text-sm rounded-md bg-gray-100 border border-gray-300 text-gray-700">Total: {totalQuestions} </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl border p-5 mt-4">
                      <h3 className="font-semibold text-gray-800 mb-4">  Question Type Distribution</h3>
                      {Object.keys(QUESTION_TYPE_LABELS).map(typeKey => {
                        const available = questionTypeCounts?.[typeKey] || 0;
                        const selected = selectedDistribution?.[typeKey] || 0;
                        return (
                          <div key={typeKey} className="flex justify-between items-center border-b py-3" >
                            <span className="text-gray-700"> {QUESTION_TYPE_LABELS[typeKey]}  </span>
                            <div className="flex items-center gap-4">
                              <span className="text-sm text-gray-500"> {available} available </span>
                              <input id={`variant-dist-input-${section.id}-${typeKey}`} type="number" min={0} max={available} value={selected} onKeyDown={(e) => { if (e.key === '-' || e.key === 'e' || e.key === '.') e.preventDefault(); }} className="w-20 border border-gray-300 rounded-md px-2 py-1 text-center"
                                onChange={(e) => updateVariantQuestionDistribution(section.id, activeVariantDifficulty, typeKey, e.target.value, available)} />
                            </div>
                          </div>
                        );
                      }
                      )}

                      <div className={`flex justify-between items-center mt-4 border rounded-md px-4 py-2 ${isVariantDistComplete ? "bg-green-50 border-green-300" : "bg-red-50 border-red-300"}`}>
                        <span className={`font-medium text-sm ${isVariantDistComplete ? "text-green-700" : "text-red-600"}`}>
                          {isVariantDistComplete ? "✓ All questions distributed" : `${variantDistTarget - totalSelected} questions not yet allocated`}
                        </span>
                        <span className="text-sm font-medium text-gray-700">
                          {totalSelected} / {variantDistTarget}
                        </span>
                      </div>
                      {variantErr.questionDistribution && (<p className="text-red-500 text-xs mt-2">{variantErr.questionDistribution}</p>)}
                    </div>
                  </>
                );
              })}
              {errors.variants && (<p className="text-red-500 text-xs mt-1 mb-2">{errors.variants}</p>)}
              {!showBreakConfig && isAdaptive && (
                <div className="border-2 border-dashed rounded-xl p-10 text-center mb-6">
                  <p className="text-gray-500">No break screens configured</p>
                  <p className="text-sm text-gray-400">Add breaks to help learners stay focused</p>
                </div>
              )}

              {(showBreakConfig || breakpages.length > 0) && isAdaptive && (
                <div className="border rounded-xl p-6 space-y-5 mb-6">
                  <div className="flex justify-between items-center">
                    <span className="font-medium">Break Screens</span>
                    <button id="add-break-btn" onClick={addBreakScreen} className="text-blue-500 text-sm" >+ Add Break </button>
                  </div>

                  {breakpages && breakpages?.map((breakpage) => (
                    <div key={breakpage.id} className="border p-4 rounded-lg space-y-3">
                      <div className="flex justify-end">
                        <button id={`remove-break-screen-btn-${breakpage.id}`} onClick={() => removeBreakScreen(breakpage.id)} className="text-red-500"><Trash2 className="w-5 h-5" /></button>
                      </div>
                      <div>
                        <label className="text-sm font-medium">Break Title</label>
                        <input id={`break-title-input-${breakpage.id}`} placeholder="title" name="title"
                          value={breakpage.title} onChange={(e) => handleChangeBreakPage(breakpage.id, e)} className="w-full border rounded-lg px-4 py-2 mt-1" />
                      </div>
                      <div>
                        <label className="text-sm font-medium">Message</label>
                        <textarea id={`break-message-input-${breakpage.id}`} placeholder="message" name="message"
                          value={breakpage.message} onChange={(e) => handleChangeBreakPage(breakpage.id, e)} className="w-full border rounded-lg px-4 py-2 mt-1" />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {errors.common && (<p className="text-red-500 text-xs mt-1 mb-2">{errors.common}</p>)}
              {errors.break && (<p className="text-red-500 text-xs mt-1 mb-2">{errors.break}</p>)}

              <DisplayConfiguration onChange={handleDisplayConfigChange} initialValues={displayConfig} errors={errors.displayConfig} />
              <ButtonLabel assessmentDetail={assessmentDetail} handleCancel={handleCancel} handleUpdateAssessment={handleUpdateAssessment} isPublishing={isPublishing} handlePublish={handlePublish} />
            </>
          }

          {activeTab === "preview" && previewData && (
            <Preview previewData={previewData} handleDragOver={handleDragOver} handleDrop={handleDrop} sectionBreaks={sectionBreaks} handleDragStart={handleDragStart} isAdaptive={isAdaptive} />
          )}
        </div>
      </div>
      {showCancelModal && (
        <div id="cancel-assessment-modal" className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <h3 className="text-lg font-semibold mb-2"> Cancel Assessment?</h3>
            <p className="text-sm text-gray-600 mb-6"> Are you sure you want to cancel? Any unsaved changes will be lost.</p>
            <div className="flex justify-end gap-3">
              <button id="cancel-modal-no-btn" onClick={closeCancelModal} className="px-4 py-2 border rounded text-sm hover:bg-gray-100">No</button>
              <button id="cancel-modal-yes-btn" onClick={confirmCancel} className="px-4 py-2 bg-red-600 text-white rounded text-sm hover:bg-red-700">Yes, Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showVariantDeleteModal && (
        <div id="variant-delete-modal" className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <h3 className="text-lg font-semibold mb-2">Delete Module?</h3>
            <p className="text-sm text-gray-600 mb-6"> Are you sure you want to delete this module? This action cannot be undone.</p>
            <div className="flex justify-end gap-3">
              <button id="variant-delete-cancel-btn" onClick={closeVariantDeleteModal} className="px-4 py-2 border rounded text-sm hover:bg-gray-100">Cancel</button>
              <button id="variant-delete-confirm-btn" onClick={confirmVariantDelete} className="px-4 py-2 bg-red-600 text-white rounded text-sm hover:bg-red-700"> Delete </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssessmentCreate;